module.exports = __webpack_public_path__ + "img/submit.e22735f.png";